module.exports = __webpack_public_path__ + "static/media/tubteam.fb9135e1.jpeg";